<template>
  <div class="layout">
    <Head :navList="navList" />
    <el-backtop
      title="回到顶部"
      :visibility-height="400"
      :right="70"
      :bottom="53"
    ></el-backtop>
    <keep-alive>
      <router-view
        :key="$route.path"
        v-if="$route.meta.keepAlive"
      ></router-view>
    </keep-alive>
    <router-view :key="$route.path" v-if="!$route.meta.keepAlive"></router-view>
    <Foot :navList="navList" />
  </div>
</template>

<script>
import navList from "./navList";
import Head from "./components/head";
import Foot from "./components/foot";
export default {
  data() {
    return {
      navList,
    };
  },
  components: {
    Head,
    Foot,
  },
  created() {
    this.$store.setNavList(navList); // store赋值
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.layout {
  &::before {
    content: "";
    display: table;
  }
}
</style>
